<template>
  <div class="partners">
    <div v-if="filters && filters.length > 0" class="partner-filter">
      <div class="filter">
        <p v-if="filtersLabel" class="filter__title">
          <span>{{ filtersLabel }}</span>
        </p>
        <div v-for="name in filters" :key="name.id" class="checkbox-container">
          <label class="c-checkbox" :for="`${name.id}`">
            <input
              type="checkbox"
              name="partners"
              class="c-checkbox"
              :checked="isSelected(name.id)"
              :id="`${name.id}`"
              :value="name.id"
              @change="togglePartner"
            />
            <span>{{ name.fields.name.value }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="partner-list">
      <!-- With Featured Image List -->
      <div v-for="item in itemsWithFeaturedImage" :key="item.id" class="partner-list__item">
        <template v-if="item && item.partnerTypes && item.partnerTypes.value">
          <a v-if="item.featuredImage && item.featuredImage.src" :href="item.url">
            <img :src="item.featuredImage.src" :alt="item.featuredImage.alt" />
            <!-- Only Shows if Partners Option "CIS Security Benchmarks Security Vendor Members Certified" is selected -->
            <div v-if="partnerLength(item.partnerTypes.value) > 0" class="partner-list__certified">
              <span
                v-for="(a, index) in getPartnerDisplayname(item.partnerTypes.value)"
                :key="a.id"
              >
                <span v-if="a.name === 'cis-controls-accredited-partner-type'" class="link"
                  >Accredited</span
                ><span
                  v-if="
                    a.name ===
                    'cis-security-benchmarks-security-vendor-members-certified-partner-type'
                  "
                  class="link"
                  >Certified</span
                ><span
                  v-if="partnerLength(item.partnerTypes.value) > 1 && index === 0"
                  class="pipe"
                >
                  |
                </span>
              </span>
            </div>
          </a>
        </template>
      </div>

      <!-- No Featured Image List -->
      <div class="nofeaturedImage">
        <div v-for="item in itemsWithoutFeaturedImage" :key="item.id">
          <a
            v-if="
              item.resourceContent &&
              item.resourceContent.value &&
              item.resourceContent.value.length > 0
            "
            :href="item.url"
            >{{ item.pageTitle.value }}</a
          >
          <span v-else>{{ item.pageTitle.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useQuery } from '@vue/apollo-composable';
import { ItemsQuery } from './CIS-Resource-PartnerListing.graphql';

const filterSort = (a, b) => {
  const nameA = a?.pageTitle?.value?.trim().toUpperCase();
  const nameB = b?.pageTitle?.value?.trim().toUpperCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

export default {
  name: 'CIS-Resource-PartnerListing',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  data: () => {
    return {
      selectedPartnersIds: []
    };
  },
  setup(props) {
    const { result, loading, error } = useQuery(ItemsQuery);

    return {
      result,
      loading,
      error
    };
  },
  computed: {
    itemsWithFeaturedImage() {
      if (this.loading) return [];

      const output = this.result?.item?.children
        .filter((c) => {
          if (
            c?.partnerTypes &&
            c?.partnerTypes?.value &&
            c?.featuredImage &&
            c?.featuredImage?.src
          ) {
            const partnerArray = c?.partnerTypes?.value
              ?.replaceAll('{', '')
              .replaceAll('}', '')
              .split('|');
            return this.partners?.some((name) => partnerArray?.includes(name?.id?.toUpperCase()));
          }
        })
        .filter((s) => {
          if (this.selectedPartnersIds.length > 0) {
            const myArray = s.partnerTypes?.value
              ?.replaceAll('{', '')
              .replaceAll('}', '')
              .split('|');

            return this.selectedPartnersIds.some((name) => myArray.includes(name?.toUpperCase()));
          } else {
            return s;
          }
        })
        ?.sort(filterSort);

      return output;
    },
    itemsWithoutFeaturedImage() {
      if (this.loading) return [];

      const output = this.result?.item?.children
        .filter((c) => {
          if (
            c?.partnerTypes &&
            c?.partnerTypes?.value &&
            c?.featuredImage &&
            !c?.featuredImage?.src
          ) {
            return this.partners?.some(
              (name) =>
                name?.id?.toUpperCase() ===
                c?.partnerTypes?.value?.replaceAll('{', '').replaceAll('}', '')
            );
          }
        })
        .filter((s) => {
          if (this.selectedPartnersIds.length > 0) {
            return this.selectedPartnersIds.some(
              (name) =>
                name?.toUpperCase() ===
                s.partnerTypes?.value?.replaceAll('{', '').replaceAll('}', '')
            );
          } else {
            return s;
          }
        })
        ?.sort(filterSort);

      return output;
    },
    partners() {
      return this.fields?.partners || [];
    },
    filters() {
      return this.fields?.filters || [];
    },
    filtersLabel() {
      return this.fields?.filtersLabel?.value;
    }
  },
  methods: {
    getPartnerDisplayname(value) {
      let partnerArray;

      if (value) {
        partnerArray = value
          ?.replaceAll(/-/g, '')
          .replaceAll('{', '')
          .replaceAll('}', '')
          .split('|');
      }

      const partners = this.result?.partners?.children.filter((s) => {
        return partnerArray?.includes(s?.id);
      });

      return partners;
    },
    partnerLength(value) {
      let partnerArray;

      if (value) {
        partnerArray = value
          ?.replaceAll(/-/g, '')
          .replaceAll('{', '')
          .replaceAll('}', '')
          .split('|');
      }

      const selectedPartners = this.result?.partners?.children?.filter((s) => {
        return partnerArray?.includes(s?.id);
      });

      let matchedPartners = selectedPartners?.filter((s) => {
        let option = '';

        if (s?.name === 'cis-security-benchmarks-security-vendor-members-certified-partner-type')
          option = 'Certified';

        if (s?.name === 'cis-controls-accredited-partner-type') option = 'Accredited';
        return option;
      });

      return matchedPartners?.length;
    },
    isSelected(partnerId) {
      return !!this.selectedPartnersIds.includes(partnerId);
    },
    togglePartner(e) {
      let partnerId = e.target?.value || e.srcElement?.value;

      // find partner object by its Id in the list of filters
      const partner = this.filters.find(({ id }) => id === partnerId);
      if (!partner) return;

      // look for partner.id in list of selectedPartnersIds
      const partnerIdIndex = this.selectedPartnersIds.findIndex((t) => t === partner.id);

      // if found, remove it
      if (partnerIdIndex >= 0) {
        this.selectedPartnersIds.splice(partnerIdIndex, 1);
      } else {
        // else, add it
        this.selectedPartnersIds.push(partner.id);
      }

      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.partners {
  @include tablet-up {
    display: flex;
    margin-top: 5rem;
  }

  .partner {
    &-filter {
      background: $white;

      @include tablet-up {
        width: 25%;
      }

      .filter {
        background-color: $white;
        padding: 2rem;
        margin-bottom: 2rem;
        border: 0.5px solid #f3f4f4;
        box-shadow: 0 16px 16px 0 rgba(0, 0, 0, 0.04), 0 4px 8px 0 rgba(0, 0, 0, 0.04);

        @include tablet-up {
          position: sticky;
          top: 5.5rem;
          z-index: 1;
          display: block;
        }

        &__title {
          display: block;
          margin-bottom: 2rem;
          @include font-styles('Arial', 2rem, 200, normal, 2.8rem, 0, $blue);

          span {
            display: block;
            font-weight: 500;
          }
        }

        .checkbox-container {
          margin-bottom: 1.5rem;

          &:last-child {
            margin-bottom: 0;
          }
        }

        input {
          display: none;
        }

        label {
          display: block;
          position: relative;
          padding-left: 4rem;
          cursor: pointer;

          span {
            display: inline-block;
            @include font-styles('Arial', 1.8rem, 200, normal, 2.2rem, 0, $gray);

            @include tablet-up {
              font-size: 1.6rem;
              line-height: 2rem;
            }

            @include desktop-up {
              font-size: 1.8rem;
              line-height: 2.2rem;
            }

            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              -webkit-transform: translatey(-50%);
              transform: translatey(-50%);
              width: 2.5rem;
              height: 2.5rem;
              background-color: $white;
              transition: all 0.25s linear;
              border: 0.15rem solid $blue;
            }
          }

          &.c-radio {
            input:checked + span:after {
              content: '';
              position: absolute;
              left: 0.5rem;
              top: 50%;
              -webkit-transform: translatey(-50%);
              transform: translatey(-50%);
              width: 1.5rem;
              height: 1.5rem;
              background-color: $blue;
              transition: all 0.25s linear;
            }
          }

          &.c-checkbox {
            span {
              &::before {
                top: 1.25rem;

                @include tablet-up {
                  top: 1.6rem;
                }
              }
            }

            input:checked + span:after {
              content: '';
              position: absolute;
              left: 0.3rem;
              top: 0.2rem;
              color: $white;
              transition: all 0.25s linear;
              background-image: url(~@/assets/images/icon-checkbox-checkmark.svg);
              background-size: contain;
              width: 2rem;
              height: 2rem;

              @include tablet-up {
                top: 0.6rem;
              }
            }
          }
        }
      }
    }

    &-list {
      max-width: $site-max-width;
      margin: 0 auto;
      padding: 2rem 0;

      @include tablet-up {
        display: flex;
        flex-wrap: wrap;
        width: 75%;
      }

      &__item {
        margin: 0 4rem 8rem 4rem;
        text-align: center;

        @include tablet-up {
          display: flex;
          width: calc(100% / 3 - 12rem);
          margin: 0 6rem 5rem 6rem;
          align-items: center;
          justify-content: center;
        }

        img {
          max-height: 10rem;
          max-width: 100%;
        }

        .partner-list__certified {
          text-align: center;
          color: $blue;
          font-size: 1.6rem;
          font-weight: 500;

          &:before {
            content: '(';
            color: $gray;
            padding-right: 0.2rem;
          }

          &:after {
            content: ')';
            color: $gray;
            padding-left: 0.2rem;
          }

          .link {
            &:hover {
              text-decoration: underline;
            }
          }

          .pipe {
            color: $gray;
          }
        }
      }

      .nofeaturedImage {
        clear: both;
        width: 100%;

        @include tablet-up {
          display: flex;
          flex-wrap: wrap;
        }

        > div {
          margin-bottom: 1rem;

          @include tablet-up {
            flex-basis: 50%;
          }

          a,
          span {
            display: inline-block;
            padding-right: 2rem;
          }
        }
      }
    }
  }
}
</style>
